module.exports = new __parcel__URL__("pattern.44a3d5b1.png").toString();